/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BanPatientDialog.vue?vue&type=template&id=76129f7f"
import script from "./BanPatientDialog.vue?vue&type=script&lang=js"
export * from "./BanPatientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76129f7f')) {
      api.createRecord('76129f7f', component.options)
    } else {
      api.reload('76129f7f', component.options)
    }
    module.hot.accept("./BanPatientDialog.vue?vue&type=template&id=76129f7f", function () {
      api.rerender('76129f7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/BanPatientDialog.vue"
export default component.exports